import axios from "axios";

// ========================================
// API BASE URL
// ========================================

const API_URL =
  process.env.REACT_APP_API_URL;

// ========================================
// AXIOS INSTANCE
// ========================================

export const apiClient =
  axios.create({
    baseURL: API_URL,

    timeout: 30000,

    headers: {
      "Content-Type":
        "application/json",
    },
  });

// ========================================
// REQUEST INTERCEPTOR
// ========================================

apiClient.interceptors.request.use(

  (config) => {

    // ========================================
    // JWT TOKEN
    // ========================================

    const token =
      localStorage.getItem("token");

    if (token) {

      config.headers.Authorization =
        `Bearer ${token}`;
    }

    // ========================================
    // OPTIONAL:
    // CUSTOM HEADERS
    // ========================================

    config.headers.Accept =
      "application/json";

    return config;
  },

  (error) => {

    return Promise.reject(error);
  }
);

// ========================================
// RESPONSE INTERCEPTOR
// ========================================

// apiClient.interceptors.response.use(

//   // SUCCESS
//   (response) => {

//     return response;
//   },

//   // ERROR
//   (error) => {

//     // ========================================
//     // NETWORK ERROR
//     // ========================================

//     if (!error.response) {

//       console.error(
//         "Network Error"
//       );

//       return Promise.reject(
//         new Error(
//           "Unable to connect to server"
//         )
//       );
//     }

//     // ========================================
//     // STATUS
//     // ========================================

//     const status =
//       error.response.status;

//     // ========================================
//     // UNAUTHORIZED
//     // ========================================

//     if (status === 401) {

//       localStorage.removeItem(
//         "token"
//       );

//       localStorage.removeItem(
//         "nsj_session"
//       );

//       window.location.href =
//         "/admin/login";
//     }

//     // ========================================
//     // FORBIDDEN
//     // ========================================

//     if (status === 403) {

//       console.error(
//         "Access Denied"
//       );
//     }

//     // ========================================
//     // SERVER ERROR
//     // ========================================

//     if (status >= 500) {

//       console.error(
//         "Server Error"
//       );
//     }

//     // ========================================
//     // API MESSAGE
//     // ========================================

//     const message =
//       error.response?.data?.message ||
//       error.message ||
//       "Something went wrong";

//     return Promise.reject(
//       new Error(message)
//     );
//   }
// );

apiClient.interceptors.response.use(

  (response) => response,

  (error) => {

    if (!error.response) {

      return Promise.reject(
        new Error(
          "Unable to connect to server"
        )
      );
    }

    const status =
      error.response.status;

    if (status === 401) {

      localStorage.removeItem("token");

      localStorage.removeItem(
        "nsj_session"
      );

      window.location.href =
        "/admin/login";
    }

    // ========================================
    // VALIDATION ERRORS
    // ========================================

    const validationErrors =
      error.response?.data?.errors;

    if (validationErrors) {

      const messages =
        Object.values(validationErrors)
          .flat()
          .join("\n");

      return Promise.reject(
        new Error(messages)
      );
    }

    // ========================================
    // NORMAL MESSAGE
    // ========================================

    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong";

    return Promise.reject(
      new Error(message)
    );
  }
);

// ========================================
// EXPORT DEFAULT
// ========================================

export default apiClient;